import(/* webpackMode: "eager" */ "/home/r11/choice-graphics/node_modules/.pnpm/next@16.2.7_@babel+core@7.29.7_@opentelemetry+api@1.9.1_@playwright+test@1.60.0_react-d_a91a578b9f152ddae170ad48d856e636/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/r11/choice-graphics/node_modules/.pnpm/next@16.2.7_@babel+core@7.29.7_@opentelemetry+api@1.9.1_@playwright+test@1.60.0_react-d_a91a578b9f152ddae170ad48d856e636/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["EditableImage"] */ "/home/r11/choice-graphics/src/components/content-edit/editable-image.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EditablePageBody"] */ "/home/r11/choice-graphics/src/components/content-edit/editable-page-body.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ColourConsultCTA"] */ "/home/r11/choice-graphics/src/components/content/colour-consult-cta.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CTA"] */ "/home/r11/choice-graphics/src/components/content/cta.tsx");
;
import(/* webpackMode: "eager" */ "/home/r11/choice-graphics/src/components/ui/icon.tsx");
